import { FeatureFlags, useFeatureFlags } from '@/helper/FeatureFlags';
import { useAdminRoute } from '@/pages/corporate/routes/hooks/useAdminRoutes';
import { PerformanceStatusEnum } from '@/types/schema';

import useContentViewProgress from '../../hooks/useContentViewProgress';

interface ContentViewEventsProps {
  entityId: string;
  performanceStatus?: PerformanceStatusEnum;
  pause?: boolean;
  canConsume?: boolean;
}

const ContentViewEvents: React.FC<ContentViewEventsProps> = ({
  entityId,
  performanceStatus,
  pause,
  canConsume,
}) => {
  const isAdminRoute = useAdminRoute();

  const {
    [FeatureFlags.DisableContentAccessEventOnCompletion]: disableContentAccessEventOnCompletion,
  } = useFeatureFlags();

  const disableContentAccessEvents = Boolean(
    disableContentAccessEventOnCompletion && performanceStatus === PerformanceStatusEnum.Completed,
  );

  useContentViewProgress({
    entityId,
    pause: !entityId || pause || isAdminRoute,
    isContentVisited: !disableContentAccessEvents,
    isSetView: canConsume,
  });

  return null;
};

export default ContentViewEvents;
